<tec-list-layout>
    <tec-title-group [title]="'USERS.TITLE' | translate" [description]="'USERS.DESCRIPTION' | translate">
        @if (rolePermissions.isSuperadmin()) {
            <tec-button [label]="'USERS.LIST.MANAGE_USERS' | translate" type="secondary" (clickEvent)="goToManage()" />
        }
    </tec-title-group>

    <ng-container content>
        <!-- ERROR  -->
        @if(alertError) {
        	<tec-alert status="error" [msg]="alertError" (closeAlert)="alertError = ''" />
        }

		<tec-table-filter [selection]="{all: false, ids: []}">
			<tec-toolbar
				[toolbar]="toolbar()"
				(formFilter)="filterChange($event)"
				(actionClick)="onToolbarAction($event)"
			/>
			<tec-table
				[headers]="header"
				[rows]="content"
				[config]="config"
				(sortEvent)="sortChange($event)"
				(cellEvent)="tableCell($event)"
				(paginationChange)="paginationChange($event)"
			/>
		</tec-table-filter>
    </ng-container>
</tec-list-layout>

@if(showForm) {
	<app-users-form [detail]="userSelected" (closeEvent)="closeForm($event)" />
}

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_USERS_LIST'"
		[curlText]="getUsersListCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
